import React, { FC, useEffect, useMemo, useState } from 'react';
import { Grid, Tabs } from '@mui/material';
import MuiTab from '@material-ui/core/Tab';
import { FieldErrors } from 'react-hook-form';
import { IStatefulTab } from './types';

interface IProps {
  tabs: IStatefulTab[];
  defaultValue?: string;
  errors: Record<string, FieldErrors>;
  onChange?: (value: string) => void;
}

const StatefulTabs: FC<IProps> = ({ tabs, defaultValue, errors, onChange }) => {
  const initialTab = useMemo(
    () => tabs.find(x => x.value === defaultValue) ?? tabs[0],
    [tabs, defaultValue],
  );

  const [currentTab, setCurrentTab] = useState(initialTab);

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(tabs.find(x => x.value === newValue));
    onChange?.(newValue);
  };

  useEffect(() => {
    const errorKeys = Object.keys(errors);

    if (currentTab.inputNames.some(x => errorKeys.includes(x))) {
      return;
    }

    const tabWithError = tabs.find(x => x.inputNames.some(y => errorKeys.includes(y)));

    if (tabWithError) {
      setCurrentTab(tabWithError);
    }
  }, [errors]);

  if (!tabs.length) return <></>;

  return (
    <>
      <Grid container alignItems="center">
        <Grid item>
          <Tabs
            value={currentTab.value}
            TabIndicatorProps={{ children: <span /> }}
            onChange={handleChange}
          >
            {tabs.map(tab => (
              <MuiTab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                disableRipple
                disabled={tab.disabled}
              />
            ))}
          </Tabs>
        </Grid>
        <Grid item xs />
      </Grid>

      <div>{currentTab.component}</div>
    </>
  );
};

export default StatefulTabs;
